import { render, staticRenderFns } from "./ImportKolBasicRecord.vue?vue&type=template&id=3602f455&scoped=true"
import script from "./ImportKolBasicRecord.vue?vue&type=script&lang=js"
export * from "./ImportKolBasicRecord.vue?vue&type=script&lang=js"
import style0 from "./ImportKolBasicRecord.vue?vue&type=style&index=0&id=3602f455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3602f455",
  null
  
)

export default component.exports